import { deserialize, object, serializable } from 'serializr';

export enum APIStepEntityType {
  SALESFORCE_API,
}

export enum APIStepDataGenArgValueType {
  RAW,
  }

export class SalesforceAPIStepDataGeneratorArgument {
  @serializable
  public id: number;

  @serializable
  public entityType: APIStepEntityType;

  @serializable
  public entityId: number;

  @serializable
  public argumentName: string;

  @serializable
  public argumentValue: string;

  @serializable
  public argumentValueType: APIStepDataGenArgValueType;

  @serializable
  public functionId: number;

  @serializable
  public phoneNumberId: number;

  @serializable
  public mailboxId: number;

  deserialize(input: any): this {
    return Object.assign(
      this,
      deserialize(SalesforceAPIStepDataGeneratorArgument, input),
    );
  }
}
